function setModal() {
  const detailsMmodal = document.querySelector('.details-modal');
  if (!detailsMmodal) return;
  const modal = detailsMmodal.closest('details');
  const btnModal = document.querySelector('.btn-modal');
  const btnModalClose = document.querySelector('.details-modal-close');
  
  btnModal?.addEventListener('click', () => {
    modal.open = true;
  });
  
  btnModalClose?.addEventListener('click', () => {
    modal.open = false;
  });
  
  modal.addEventListener('click', (e) => {
    if (e.target === modal) {
      modal.open = false;
    }
  });
}

setModal();